import RadioOption from '~/components/RadioOption';
import TextInputWithInlineLabel from '~/components/TextInputWithInlineLabel';
import MoneyInput from '~/components/MoneyInput';

const DISCOUNT_TYPES = {
    PERCENT: '%',
    FIXED: '$',
};

const DiscountTypeInput = ({ value, onChange }) => {
    const isFixed = value?.type === DISCOUNT_TYPES.FIXED;
    const isPercent = value?.type !== DISCOUNT_TYPES.FIXED;

    return (
        <div className="pl-6">
            <div className="flex items-center justify-between pr-6">
                <RadioOption
                    label="Percent"
                    description="Provide a percentage off"
                    checked={isPercent}
                    onChange={() =>
                        onChange({ ...value, type: DISCOUNT_TYPES.PERCENT })
                    }
                />
                {isPercent && (
                    <TextInputWithInlineLabel
                        prefix="%"
                        className="max-w-32"
                        placeholder="0"
                        min="0"
                        inputClassName="pl-8"
                        required={true}
                        autoFocus={!value?.percentDiscount}
                        value={value?.percentDiscount || ''}
                        onChange={newValue =>
                            onChange({ ...value, percentDiscount: Math.min(Math.max(0, newValue), 100) })
                        }
                    />
                )}
            </div>

            <div className="border-t flex items-center justify-between pr-6">
                <RadioOption
                    label="Fixed"
                    description="Provide a fixed amount off"
                    checked={isFixed}
                    onChange={() =>
                        onChange({ ...value, type: DISCOUNT_TYPES.FIXED })
                    }
                />
                {isFixed && (
                    <MoneyInput
                        className="max-w-32"
                        autoFocus={!value?.fixedDiscount}
                        value={value?.fixedDiscount || ''}
                        required={true}
                        min="0"
                        onChange={newValue =>
                            onChange({ ...value, fixedDiscount: Math.max(0, newValue) })
                        }
                    />
                )}
            </div>
        </div>
    );
};

export default DiscountTypeInput;
